import { useV2ListAccountCallbacksForAccountQuery } from "@generated";
import type { AccountCallback } from "../types";

// The account has at most one legacy callback; a list-of-one drives the
// empty (-> notice) vs. present (-> form) decision in Edit.
export const useAccountCallback = () => {
  const { data, isLoading, refetch } = useV2ListAccountCallbacksForAccountQuery(
    {},
    { refetchOnMountOrArgChange: true }
  );

  const record = data?.data?.[0];
  const callback: AccountCallback | null = record
    ? {
        id: String(record.id),
        redirectUri: record.attributes?.["redirect-uri"] ?? "",
        clientId: record.attributes?.["client-id"] ?? "",
      }
    : null;

  return { callback, isLoading, refetch };
};

export default useAccountCallback;
